import React from "react";
import env from "../../../../config";
import { useParams } from "react-router-dom";
import IframeSendData from "../../../../helper/IframeSendData";
import { useSSOInfo } from "../../../../context/sso";
const ProviderView = () => {
  const { companyId, appId } = useParams();
  const [SSODat] = useSSOInfo();
  return (
    <div>
      <IframeSendData
        SSOData={SSODat}
        iframeUrl={`${env.CUSTOMPAGE_URL}/agency/${companyId}/${appId}/dashboard`}
      />
    </div>
  );
};

export default ProviderView;
